export const COURSE_INTEGRITY = {
  NONE: 'none',
  MID: 'mid',
  STRICT: 'strict',
};

export const DEFAULT_EXAM_TIME_PER_QUESTION = '60';

// Compute the examTimeLimitSeconds value to submit via updateCourse.
// Only strict courses submit a value; for non-strict integrity we return
// undefined so the field is omitted and the backend coerces it to 0.
export const getExamTimeLimitToSubmit = (integrity, rawValue) => {
  if (integrity !== COURSE_INTEGRITY.STRICT) {
    return undefined;
  }
  return parseInt(rawValue, 10) || 0;
};

// Whether the exam time-per-question input should be prefilled with the
// default when integrity is strict and no positive value is stored yet.
export const shouldPrefillExamTime = (integrity, rawValue) =>
  integrity === COURSE_INTEGRITY.STRICT && (!rawValue || rawValue === '0');
